import { render, staticRenderFns } from "./rewardTrafficPermitEditNew.vue?vue&type=template&id=fe463af8&scoped=true&"
import script from "./rewardTrafficPermitEditNew.vue?vue&type=script&lang=js&"
export * from "./rewardTrafficPermitEditNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe463af8",
  null
  
)

export default component.exports